import styled from '@emotion/styled';

import SimplePageLayout from 'components/SimplePageLayout';

import { ProtectedRouteComponentProps } from '../ProtectedRoute';
import { AccessDenied } from '../AccessDenied';

import { Button } from 'components';

import colors from 'lib/colors';

interface Props extends ProtectedRouteComponentProps {}

const Theme: React.FunctionComponent<Props> = ({ user }) => {
  // Not for everyone :)
  if (user && user.company) {
    return <AccessDenied />;
  }

  return (
    <SimplePageLayout>
      <Grid>
        <Button label="default" variant="default" />

        <Button label="danger" variant="danger" />

        <Button label="warning" variant="warning" />

        <Button label="warningFaded" variant="warningFaded" />

        <Button label="transparent" variant="transparent" />

        <Button label="transparent70" variant="transparent70" />

        <Button label="primary" variant="primary" />
        <Button label="outline-primary" variant="outline-primary" />
      </Grid>

      <Grid>
        <DivColor css={{ backgroundColor: colors.employee }}>employee</DivColor>
        <DivColor css={{ backgroundColor: colors.hacker }}>hacker</DivColor>
      </Grid>

      <Grid>
        <DivColor css={{ backgroundColor: colors.background }}>
          background
        </DivColor>
        <DivColor css={{ backgroundColor: colors.darkBackground }}>
          darkBackground
        </DivColor>
        <DivColor css={{ backgroundColor: colors.secondaryDarkBackground }}>
          secondaryDarkBackground
        </DivColor>
        <DivColor css={{ backgroundColor: colors.darkGray }}>darkGray</DivColor>
        <DivColor css={{ backgroundColor: colors.darkBlue }}>darkBlue</DivColor>
      </Grid>
      <Grid>
        <DivColor css={{ backgroundColor: colors.hackerBg }}>hackerBg</DivColor>
        <DivColor css={{ backgroundColor: colors.employeeBg }}>
          employeeBg
        </DivColor>
        <DivColor css={{ backgroundColor: colors.bottomBar }}>
          bottomBar
        </DivColor>

        <DivColor css={{ backgroundColor: colors.white }}>white</DivColor>
        <DivColor css={{ backgroundColor: colors.black }}>black</DivColor>
        <DivColor css={{ backgroundColor: colors.gray }}>gray</DivColor>
      </Grid>

      <Grid>
        <DivColor css={{ backgroundColor: colors.lobbyOrange }}>
          lobbyOrange
        </DivColor>
        <DivColor css={{ backgroundColor: colors.lobbyOrangeDark }}>
          lobbyOrange dark
        </DivColor>
        <DivColor css={{ backgroundColor: colors.primary }}>primary</DivColor>
        <DivColor css={{ backgroundColor: colors.activeAddCard }}>
          activeAddCard
        </DivColor>
        <DivColor css={{ backgroundColor: colors.deckBorder }}>
          deckBorder
        </DivColor>

        <DivColor css={{ backgroundColor: colors.cardBackground }}>
          cardBackground
        </DivColor>
      </Grid>

      <Grid>
        <DivColor css={{ backgroundColor: colors.danger }}>danger</DivColor>
        <DivColor css={{ backgroundColor: colors.success }}>success</DivColor>
        <DivColor css={{ backgroundColor: colors.successDark }}>
          successDark
        </DivColor>
        <DivColor css={{ backgroundColor: colors.warning }}>warning</DivColor>
        <DivColor css={{ backgroundColor: colors.warningFaded }}>
          warningFaded
        </DivColor>
      </Grid>
      <Grid>
        <DivColor css={{ backgroundColor: colors.disabledInputBg }}>
          disabledInputBg
        </DivColor>
        <DivColor css={{ backgroundColor: colors.disabledInputText }}>
          disabledInputText
        </DivColor>
      </Grid>

      <Grid>
        <DivColor css={{ backgroundColor: colors.employeeLight }}>
          employeeLight
        </DivColor>
        <DivColor css={{ backgroundColor: colors.hackerLight }}>
          hackerLight
        </DivColor>
      </Grid>
      <Grid>
        <DivColor css={{ backgroundColor: colors.employeeCardBorder }}>
          employeeCardBorder
        </DivColor>
        <DivColor css={{ backgroundColor: colors.hackerCardBorder }}>
          hackerCardBorder
        </DivColor>
      </Grid>

      <Grid>
        <DivColor css={{ backgroundColor: colors.lobbyText }}>
          lobbyText
        </DivColor>
        <DivColor css={{ backgroundColor: colors.infoLinks }}>
          infoLinks
        </DivColor>
        <DivColor css={{ backgroundColor: colors.purple }}>purple</DivColor>

        <DivColor css={{ backgroundColor: colors.sunriseViolet }}>
          sunriseViolet
        </DivColor>
        <DivColor css={{ backgroundColor: colors.passwordToggle }}>
          passwordToggle
        </DivColor>
        <DivColor css={{ backgroundColor: colors.green }}>green</DivColor>

        <DivColor css={{ backgroundColor: colors.onlineUsers }}>
          onlineUsers
        </DivColor>
        <DivColor css={{ backgroundColor: colors.chatMessage }}>
          chatMessage
        </DivColor>
      </Grid>
      <Grid>
        <DivColor css={{ backgroundColor: colors.transparent }}>
          transparent
        </DivColor>
        <DivColor css={{ backgroundColor: colors.transparent70 }}>
          transparent70
        </DivColor>
      </Grid>
    </SimplePageLayout>
  );
};

export default Theme;

const DivColor = styled('div')({
  height: 30,
  minWidth: 210,
  border: '1px solid black',
});

const Grid = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gridGap: '1em',

  marginTop: 15,
  marginBottom: 15,
});
